// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eSUt","question":"styles_question___pg5Q","description":"styles_description__3psgo"};